import styled from "styled-components";
import { borderWidth, borderStyle, borderRadius as radius } from "../../../design-system/tokens/borders";
import type { KgNodeVisualState } from "../../kg/kgNodeShared.types";

export const Badge = styled.div<{
  $color: string;
  $bgColor: string;
  $visualState: KgNodeVisualState;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: ${radius.lg};
  border: ${borderWidth[1]} ${({ $visualState }) =>
    $visualState === "draft" ? borderStyle.dashed : borderStyle.solid}
    ${({ $color }) => $color};
  background: ${({ $bgColor }) => $bgColor};
  color: ${({ $color }) => $color};
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`;
